import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

/** Neutrale Pille für Agentenkonten (kind AGENT) in Listen und Personen-Auswahl. */
@Component({
  selector: 'app-ki-konto-pill',
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="ki-konto-pill" data-testid="ki-pill">
      <span class="ki-konto-pill__dot" aria-hidden="true"></span>
      {{ 'accountKind.agentPill' | translate }}
    </span>
  `,
  styleUrl: './ki-konto-pill.component.scss',
})
export class KiKontoPillComponent {}
